<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-8 col-8 mx-auto">
                <div class="small-box bg-warning card d-flex flex-row justify-content-center">
                    <h4 class="p-2" ><span  v-if="!userprefsData || !this.userprefsData.agreedterms_cond">Disclaimer and </span>User Preferences:</h4>
                </div>
                <div class="card row text-center" v-if="disclaimer">
                    <div v-if="!userprefsData || !this.userprefsData.agreedterms_cond" class="col" style="padding:.5em;">

                        <h2 class="m-2" >Disclaimer</h2>
                        <p v-html="disclaimerText" style="text-align:left;"></p>
                    </div>
                    <h5>Please <span v-html="userprefsData?'update':'enter'"></span> your preferences<span  v-if="!userprefsData || !this.userprefsData.agreedterms_cond"><br/> and signify acceptance of the above disclaimer</span>:</h5>

                    <div class="row flex-row d-flex justify-content-between">
                        <div class="card row p-2 mx-auto">
                            <div class="p-2">
                                <small>Days per Week Available for Workout: </small>
                                <input style="width:3em;"  v-model="prefs_daysavailable" type="number" min="3" max="5">
                            </div>
                            <div class="p-2">
                                <span><b>Exercise Type:</b></span>
                                <select style="width:13em;"  v-model="prefs_exercisetype" >
                                    <option name="bodywtonly" value="bodywttrue">Body-Weight Only</option>
                                        <option name="gymwt" value="bodywtfalse">(Gym) Weights &amp; Machines</option>
                                </select>
                            </div>
                            <div  v-if="!userprefsData || !this.userprefsData.agreedterms_cond" class="p-2">
                                <span>I accept the above disclaimer</span>:<input style="width:2em;" :checked="disclaimer_tick" v-model="disclaimer_tick" type="checkbox">
                            </div>
                            <div class="p-2  justify-content-between">
                                <button :disabled="savePrefsButtonDisable()" class="btn btn-sm btn-success m-2 p-2" @click="savePrefs" >Save my Preferences</button>
                                <span v-if="!userprefsData || !this.userprefsData.agreedterms_cond"><button class="btn btn-sm btn-warning m-2 p-2" @click="notNow" >Not Now</button></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import EventBus from '../../event-bus';


export default {
    components: {
     },
    name: "UserPrefs",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            userinfo:'',
            userprefsData:[],
            // numdaysavailable:'',
            disclaimerText:'',
            prefs_daysavailable:'',
            disclaimer_tick:'',
            prefs_exercisetype:'',


        }
    },

    props: {
        userdata:'',
        disclaimer:'',
        userprefs:'',
        disclaimer_acceptedx:'',
        disclaimer_accepted:''
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.disclaimerText = JSON.parse(this.disclaimer);
        this.userprefsData = JSON.parse(this.userprefs);
        this.getData;
         if(this.userprefsData && this.userprefsData.agreedterms_cond !=null) this.disclaimer_tick = this.userprefsData.agreedterms_cond;
        if(this.userprefsData &&(this.userprefsData.agreedterms_cond != null && this.userprefsData.prefs_daysavailable >=3)) window.location('/workout/myworkout');

    },

    methods: {
        savePrefsButtonDisable() {
            if(this.userprefsData == null) return !(this.disclaimer_tick && this.prefs_daysavailable>0);
            if(this.userprefsData != null) return !(this.prefs_daysavailable && this.prefs_exercisetype);
        },
        showCert() {
            console.log("Clicked ShowCert...");
            document.getElementById('pers_cert').hidden = !document.getElementById('pers_cert').hidden;
        },
        initPerfArray(){
            this.myFSDetails.map((myd) => { this.perf[myd.life_area] = 0;});
        },
        notNow() {
            this.doubleConfirmSwal("We can't provide you with workout systems, until your preferences and disclaimer acceptance are signified.");
        },
        savePrefs() {
            this.userprefsData? this.userprefsData.agreedterms_cond = this.disclaimer_tick:'';
            var agreedtos = this.userprefsData? this.userprefsData.agreedterms_cond:(this.disclaimer_tick? Date.now(): null);

            console.log("Saving prefs.TOS: " .agreedtos);

            axios.post('/user/prefs/save', {
                user_id:this.userinfo.id,
                numdaysavailable:this.prefs_daysavailable,
                agreedterms_cond: agreedtos,
                exercise_type: this.prefs_exercisetype,

            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
               this.userprefsData =JSON.parse(res.data.userprefs);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                //location.reload();
                // this.updateToast(this.message, 4000);
                this.doubleConfirmOnSavePrefs(this.message) ;
                this.message = '';
            });
        },

        doubleConfirmSwal(message) {
            Swal.fire({
            title:message,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Skip for now',
            denyButtonText: `Let me check it out again`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire('Skipping....', '', 'success');
                    console.log("Skipping UserPrefs for user: " + this.userinfo.id );
                //transfer to SMS home.  TODO
                } else if (result.isDenied) {
                    // Swal.fire('Please review the disclaimer and submit your preferences', '', 'info')

                }
            });
        },

    doubleConfirmOnSavePrefs(message) {
            Swal.fire({
            title:message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'Thanks, got it.',
            denyButtonText: `Let me check it out again`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire('Redirecting you to your workout....', '', 'success');
                    // console.log("Skipping UserPrefs for user: " + this.userinfo.id );
                   window.location.href='/workout/myworkout';
                }
            });
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed:{
        getData() {
             this.disclaimer_acceptedx = this.disclaimer_accepted;
        if(this.userprefsData != null){
            this.prefs_daysavailable = this.userprefsData.numdaysavailable;
            if(this.userprefsData.agreedterms_cond!= null) this.disclaimer_tick = true;
            this.prefs_exercisetype = this.userprefsData.exercise_type=='bodywt'? 'bodywttrue':'bodywtfalse';
        }

        }
    }
}
</script>

<style scoped>


</style>
